import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Moon, Sun } from 'lucide';

// MUI
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

// common
import Icon from 'common/components/Icon';
import { Android12Switch } from 'common/SchemaForm/element/switch/SwitchSchema';
import { MODE_THEME } from 'common/constants';
import useGeneralHook from 'common/hook/useGeneralHook';
import { setModeTheme } from '@redux/cacheReducer';
import { AppState } from '@redux/store';

/** Một hàng bấm được cả dòng: icon mặt trời/mặt trăng morph theo chế độ + công tắc. */
export default function ThemeSwitch() {
  const { dispatch } = useGeneralHook();
  const mode = useSelector((state: AppState) => state.cache.mode);
  const isDark = mode === 'dark';

  const toggle = () => {
    const next = isDark ? 'light' : 'dark';
    Cookies.set(MODE_THEME, next);
    dispatch(setModeTheme(next));
  };

  return (
    <ButtonBase
      role="switch"
      aria-checked={isDark}
      onClick={toggle}
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 1.25,
        py: 0.75,
        borderRadius: 2,
        color: 'text.primary',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Icon icon={isDark ? Moon : Sun} size={16} />
      <Typography variant="body2" sx={{ flex: 1, textAlign: 'left', fontWeight: 500 }}>
        <FormattedMessage id="darkMode" />
      </Typography>
      <Android12Switch
        checked={isDark}
        inputProps={{ 'aria-hidden': true, tabIndex: -1 }}
        sx={{ pointerEvents: 'none', my: -1, mr: -1 }} />
    </ButtonBase>
  );
}
